import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import { useAppDispatch } from '../../data/storeConfiguration/store'
import { postGoogleCriticalTalentInfo } from '../../data/user/userActions'
import { getId, getIsUserGoogleCriticalTalent } from '../../data/user/userSelectors'
import { LOCAL_STORAGE_KEY } from '../constants/appConstants'

export const useCheckUserGoogleCriticalTalent = ({ shouldCheck }: { shouldCheck: boolean }) => {
  const dispatch = useAppDispatch()
  const lyraId = useSelector(getId)
  const { isGooglePerformanceEnabled } = useFlags()
  const isUserGoogleCriticalTalent = useSelector(getIsUserGoogleCriticalTalent)
  const shouldCallPostGoogleCriticalTalentInfo =
    localStorage.getItem(LOCAL_STORAGE_KEY.IS_USER_GOOGLE_CRITICAL_TALENT) === 'true' || !isUserGoogleCriticalTalent // For the flow where the user is already logged in -> opens microsite, they won't have the local storage key set. If isUserGoogleCriticalTalent is false, we should set it to true
  const hasCalledPostGoogleCriticalTalentInfo = useRef(false)

  useEffect(() => {
    if (
      shouldCheck &&
      isGooglePerformanceEnabled &&
      shouldCallPostGoogleCriticalTalentInfo &&
      !hasCalledPostGoogleCriticalTalentInfo.current
    ) {
      dispatch(postGoogleCriticalTalentInfo({ isUserGoogleCriticalTalent: true }))
      localStorage.removeItem(LOCAL_STORAGE_KEY.IS_USER_GOOGLE_CRITICAL_TALENT)
      hasCalledPostGoogleCriticalTalentInfo.current = true
    }
  }, [
    dispatch,
    lyraId,
    isUserGoogleCriticalTalent,
    shouldCheck,
    isGooglePerformanceEnabled,
    shouldCallPostGoogleCriticalTalentInfo,
  ])
}
